import { useState } from 'react';
import { signIn, useSession } from 'next-auth/react';
import MarketingLayout from '../components/MarketingLayout';

export default function Login() {
  const { data: session, status } = useSession();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setMessage('');

    const result = await signIn('resend', {
      email,
      redirect: false,
      callbackUrl: '/welcome-back',
    });

    setSubmitting(false);

    if (result?.error) {
      setError('We could not send a sign-in link. Please try again.');
      return;
    }

    setMessage('Check your email for a secure sign-in link.');
  }

  return (
    <MarketingLayout
      title="Sign in - 10X Planner App"
      description="Sign in or create your 10X Planner account."
      canonical="/login"
    >
      <div className="min-h-[60vh] bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-md rounded-2xl bg-white p-8 shadow-sm border border-gray-200">
          <h1 className="text-2xl font-extrabold text-gray-900">Start your 14-day free trial</h1>
          <p className="mt-3 text-sm text-gray-500">
            Enter your email and we&apos;ll send a secure sign-in link. No password to remember.
          </p>

          {status === 'authenticated' && (
            <div className="mt-6 rounded-md bg-blue-50 p-4 text-sm text-blue-700">
              You&apos;re signed in as {session.user?.email}. Continue to your planner or start
              checkout from the welcome page.
            </div>
          )}

          {message && (
            <div className="mt-6 rounded-md bg-green-50 p-4 text-sm text-green-700">
              {message}
            </div>
          )}
          {error && (
            <div className="mt-6 rounded-md bg-red-50 p-4 text-sm text-red-700">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                placeholder="you@example.com"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-md border border-transparent bg-blue-800 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-60"
            >
              {submitting ? 'Sending...' : 'Email me a secure sign-in link'}
            </button>
          </form>
        </div>
      </div>
    </MarketingLayout>
  );
}